<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
               [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
               [mode]="(isHandset$ | async) ? 'over' : 'side'"
               [opened]="(isHandset$ | async) === false">

    <mat-toolbar>
      <img class="logo-image" src="{{logoUri}}" alt="Logo" />
    </mat-toolbar>
    <mat-nav-list>
      <a mat-list-item routerLink="/home" routerLinkActive="active">
        <fa-icon class="menu-icon create-task-icon" [icon]="faCirclePlus"></fa-icon>
        Create Task
      </a>
      <a mat-list-item routerLink="/processing" routerLinkActive="active">
        <fa-icon class="menu-icon" [icon]="faHistory"></fa-icon>
        Task History
      </a>
      <a mat-list-item routerLink="/admin" routerLinkActive="active" *ngIf="authService.isAdmin">
        <fa-icon class="menu-icon" [icon]="faGear"></fa-icon>
        Administration
      </a>
      <a mat-list-item (click)="logout()">
        <fa-icon class="menu-icon" [icon]="faRightFromBracket"></fa-icon>
        Logout
      </a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary" class="mat-side-toolbar navigation-toolbar">
      <button type="button"
              aria-label="Toggle sidenav"
              mat-icon-button
              (click)="drawer.toggle()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>

      <div class="toolbar-actions">
        <div class="alpha-tag" (click)="onAlphaTagClick()">{{applicationVersion}}</div>
        <div class="feedback-tag" matTooltip="Feedback" (click)="onFeedbackTagClick()"><fa-icon [icon]="faComment"></fa-icon></div>
        <fa-icon matTooltip="Help Guide" class="menu-icon" [icon]="faCircleInfo" (click)="goToSupport()"></fa-icon>
        <fa-icon matTooltip="User Settings" class="menu-icon" [icon]="faUser" (click)="showUserSettings()"></fa-icon>
      </div>
    </mat-toolbar>
    <!-- Add Content Here -->
    <router-outlet class="navigation-content"></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<ngx-ui-loader [text]="taskModel.statusMessage"></ngx-ui-loader>
